export const COLOR_BLACK = 'rgb(17, 17, 17)';
export const COLOR_WHITE = 'rgb(255, 255, 255)';
export const COLOR_TRANSPARENT = 'rgba(0, 0, 0, 0)';
